import axios from 'axios';
import getJWT from './token';

let api = `https://api.${process.env.REACT_APP_BASE_URL || "mattk.commerce-ims.com"}`;


const tplHelpers = {

    get3PLOrders: async function(start_date, end_date, warehouse, customer, company_id, token) {
        const userToken = await getJWT(token);
        const url = `${api}/tpl/acumatica/sales-orders`;

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        const params = {
            start_date,
            end_date,
            warehouse,
            customer
        };

        try {
            const res = await axios.get(url, { headers, params });
            return res.data.Get3PLOrdersDetails;
        } catch (err) {
            return err;
        }
    },

    getPOsForNovato: async function(start_date, end_date, warehouse, customer, company_id, token) {
        const userToken = await getJWT(token);
        const url = `${api}/tpl/acumatica/purchase-orders`;
        const vendorId = "V10001509";

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        const params = {
            start_date,
            end_date,
            vendorId
        };

        try {
            const res = await axios.get(url, { headers, params });
            return res.data.PurchaseOrderByDateDetails;
        } catch (err) {
            return err;
        }
    },


    createTransferOrder: async (payload, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/tpl/acumatica/create-transfer-order`;

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            const res = await axios.post(url, JSON.stringify(payload), { headers: headers });
            return res;
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        };
    },

    sendOrdersTo3pl: async (orders, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/tpl/geodis/createOrder`;
        const stringifiedBody = JSON.stringify({
            orders
        });

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            let responseBody = await axios.post(url, stringifiedBody, { headers: headers });
            console.log(JSON.stringify(responseBody));
            return {
                success: true,
                body: responseBody
            };
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        }
    },

    getGeodisInventory: async (company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/tpl/geodis/inventory`;

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            const res = await axios.get(url, { headers });
            const inventory = res.data;
            const inventory_array = Object.keys(inventory).map((key) => inventory[key]);
            inventory_array.forEach((inventory, index) => {
                inventory['id'] = index;
            })
            return inventory_array;
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        }
    },

    getDiscrepancies: async (company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/tpl/inventory/discrepancies`;

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            const res = await axios.get(url, { headers });
            const discrepancies = res.data;
            const discrepancies_array = Object.keys(discrepancies).map((key) => discrepancies[key]);
            discrepancies_array.forEach((discrepancies, index) => {
                discrepancies['id'] = index;
            });
            return discrepancies_array;
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        }
    },

    updateDiscrepancies: async (payload, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/tpl/inventory/discrepancies/update`;

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            const res = await axios.put(url, JSON.stringify(payload), { headers });
            return res;
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        }
    },

    getAcumaticaTransferOrder: async (ordernbr, warehouse, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/tpl/acumatica/transfer-order?ordernbr=${ordernbr}&warehouse=${warehouse}`;

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            const res = await axios.get(url, { headers });
            return res.data;
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        };
    },

    sendGeodisAsn: async (transfer_order, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/tpl/geodis/asn`;
        const stringifiedBody = JSON.stringify({
            transfer_order
        });

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            await axios.post(url, stringifiedBody, { headers });
            return {
                success: true
            };
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        };
    },

    getAcumaticaRealTimeBuilds: async (ordernbr, warehouse, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/tpl/acumatica/rtbuilds?acu_order_num=${ordernbr}&warehouse=${warehouse}`;
        console.log('warehouse', warehouse)
        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            const res = await axios.get(url, { headers });
            return res.data;
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        };
    },

    cancel3PLOrder: async (order_number, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/tpl/geodis/cancelOrder`;
        const stringifiedBody = JSON.stringify({
            order_number
        });

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            await axios.post(url, stringifiedBody, { headers: headers });
            return {
                success: true
            };
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        }
    },

    get3PLShipmentConfirmation: async (start_date, end_date, company_id, token) => {
        console.log(company_id);
        const userToken = await getJWT(token);
        const url = `${api}/tpl/geodis/getShipmentConfirmation`;
        const params = {
            start_date: start_date,
            end_date: end_date
        };
        try {
            let res = await axios.get(url, { headers: { company_id:company_id[0].toUpperCase() + company_id.substring(1), Authorization: `Bearer ${userToken}` }, params});
            return {
                success: true,
                data: res
            } ;
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        }
    },

    sendOrdersToNovato: async (startDate, orders, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/bulk-orders/createSOsForNovato`;
        const stringifiedBody = JSON.stringify({
            start_date: startDate,
            orders: orders
        });

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            let responseBody = await axios.post(url, stringifiedBody, { headers: headers });
            console.log(JSON.stringify(responseBody));
            return {
                success: true,
                body: responseBody
            };
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        }
    },

}

export default tplHelpers;